cb.define([], function () {
  var AA_aa_productsofstore_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
      var self = this;
      //保存前事件
      viewmodel.on("beforeSave",function () {
        let brands = viewmodel.get("productBrands").getShowValue();
        let productClass = viewmodel.get("productClass").getRows();
        if(brands.length == 0 && productClass.length == 0){
          cb.utils.alert("商品分类范围和品牌范围不可以都为空！","error");
          return false;
        }
      });
      viewmodel.on("modeChange",function (data) {
        if(data == "browse"){
          self.setReadalbe(viewmodel);
        }else if(data == "edit"){
          self.setEditable(viewmodel);
        }else if(data == "add"){
          self.setAddAble(viewmodel);
        }
      })
    },
    //编辑态
    setEditable: function(viewmodel){
      viewmodel.get("btnEdit").setVisible(false);
      viewmodel.get("btnDelete").setVisible(false);
      viewmodel.get("btnEdit").setDisabled(true);
      viewmodel.get("btnDeleteRow").setVisible(true);
      viewmodel.get("btnAddRow").setVisible(true);
      viewmodel.get("btnSave").setVisible(true);
      viewmodel.get("btnAbandon").setVisible(true);
      viewmodel.get("productBrands").setDisabled(false);
      viewmodel.get("btnSaveAndAdd").setVisible(false);
      viewmodel.get("btnAbandonBrowst").setVisible(false);
    },
    //浏览态
    setReadalbe: function (viewmodel) {
      viewmodel.get("btnEdit").setVisible(true);
      viewmodel.get("btnDelete").setVisible(true);
      viewmodel.get("productBrands").setDisabled(false);
      viewmodel.get("btnEdit").setDisabled(false);
      viewmodel.get("btnDeleteRow").setVisible(false);
      viewmodel.get("btnAddRow").setVisible(false);
      viewmodel.get("btnSave").setVisible(false);
      viewmodel.get("btnAbandon").setVisible(false);
      viewmodel.get("btnSaveAndAdd").setVisible(false);
      viewmodel.get("btnAbandonBrowst").setVisible(true);

    },
    //新增态
    setAddAble: function(viewmodel){
      viewmodel.get("productBrands").setDisabled(false);
      viewmodel.get("btnEdit").setVisible(false);
      viewmodel.get("btnDelete").setVisible(false);
      viewmodel.get("btnDeleteRow").setVisible(true);
      viewmodel.get("btnAddRow").setVisible(true);
      viewmodel.get("btnSave").setVisible(true);
      viewmodel.get("btnAbandon").setVisible(true);
      viewmodel.get("btnSaveAndAdd").setVisible(true);
      viewmodel.get("btnAbandonBrowst").setVisible(false);
    }
  }
  try {
    module.exports = AA_aa_productsofstore_VM_extend;
  } catch (error) {

  }
  return AA_aa_productsofstore_VM_extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_productsofstore_VM.Extend.js